import { Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AuthoringBoundEditableRichText } from "authoring/components/authoring-editable-rich-text"
import { createSlot } from "lib/@components/slot/create-slot"
import { If } from "lib/@components/switch"
import { htmlToText } from "lib/html-to-text"
import { normalizeActions } from "library/normalizeActions"
import { TaskCompareDetails } from "../plugins/task-compare-details"

export const TaskContentTop = createSlot("TaskContentTop")
export const TaskContentBottom = createSlot("TaskContentBottom")

export function TaskContent() {
    const { task, taskHeader = false } = useBoundContext()
    const hasContent = !!htmlToText(task?.content)?.trim().length
    const hasNotes = !!htmlToText(task?.note)?.trim().length

    return (
        <Stack className="styled-bullets" sx={{ p: 2, mx: 2 }}>
            <TaskContentTop.Slot />
            <If truthy={taskHeader}>
                <TaskCompareDetails />
            </If>

            <If truthy={hasContent}>
                <Stack data-cy="task-content-container">
                    <Typography variant="subtitle2" sx={{ my: 1 }}>
                        Content
                    </Typography>
                    <AuthoringBoundEditableRichText field="content" transformIn={normalizeActions} />
                </Stack>
            </If>

            <If truthy={hasNotes}>
                <Stack data-cy="task-notes-container">
                    <Typography variant="subtitle2" sx={{ my: 1 }}>
                        Notes
                    </Typography>
                    <AuthoringBoundEditableRichText field="note" transformIn={normalizeActions} />
                </Stack>
            </If>
            <TaskContentBottom.Slot />
        </Stack>
    )
}
